 
import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
 
import ConectUs from "../../components/ConectUs";
 
import { motion } from "framer-motion";
 
import ImageGallery from "../../components/ImageGallery";
 import Modal from "../../components/Modal";
import DescuentosEnlinea from "./DescuentosEnlinea";
import BlockRightImage from "../../components/BlockRightImage";
import OfferLinea from "../../components/view/OfferLinea";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/4e980ff0-58d6-4d01-9ac3-dc7e149d2865" +
  "?include=field_imagen_portada.field_media_image,field_gallery.field_media_image,field_imagen2.field_media_image" +
  "&fields[node--template_home]=title,field_gallery,field_imagen_portada,field_imagen2,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function Enlinea() {


  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.2,
      },
    },
  };

  const DataDisplay = ({ data }) => {

        const hasGallery = Array.isArray(data?.galeria)
      ? data.galeria.length > 0
      : Boolean(data?.galeria);

      return(

    
    <div>
      <div className="mt-[65px]">
        <img src={data.imagen_portada} alt="cabecera" />{" "}
      </div>
       {/* Sección matricula */}
        <section className="my-12 px-4 flex justify-center">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="w-full max-w-3xl bg-gradient-to-br from-[#004270] via-[#002f52] to-slate-950 rounded-2xl shadow-xl border border-[#febe10]/20 p-8 md:p-10 flex flex-col items-center text-center gap-6"
          >
            {/* Texto y Botones (Estilo 100% estático, sin condicionales) */}
            <div
              dangerouslySetInnerHTML={{ __html: data.texto_portada }}
              className="w-full flex flex-col items-center text-center  
                /* Párrafos */
                [&_p]:text-slate-200
                        
                [&_h4]:text-[#febe10]
                  [&_h4]:mt-6
                 [&_h4]:text-lg
                [&_h4_strong]:text-lg
                 [&_h4]:p-0

                /* Título Principal h2 */
               
                [&_h2]:text-white
               [&_h2]:p-0
                [&_h2_strong]:text-white

                   [&_h3]:text-white
                      [&_h3_strong]:text-white

                /* Botón de acción principal */
                [&_a]:inline-flex
                [&_a]:items-center
                [&_a]:justify-center
                [&_a]:px-7
                [&_a]:py-3.5
                [&_a]:mt-4
                [&_a]:text-sm
                [&_a]:font-bold
                [&_a]:text-slate-950
                [&_a]:bg-[#febe10]
                [&_a]:hover:bg-[#e0a60b]
                [&_a]:rounded-xl
                [&_a]:shadow-md
                [&_a]:transition-all
                [&_a]:duration-200
                [&_a]:hover:scale-105
                [&_a]:mx-auto
              "
            />

            {/* Modal / Galería: solo se monta si existen elementos */}
            {hasGallery && (
              <div className="pt-4 border-t border-white/10 w-full flex justify-center [&_button]:text-white   [&_button]:font-bold [&_button:hover]:text-[#febe10] ">
                <Modal
                  title="Proceso de matrícula"
                  content={
                    <div className="max-w-[350px] m-auto">
                      {" "}
                      <ImageGallery gallery={data.galeria} />
                    </div>
                  }
                />
              </div>
            )}
          </motion.div>
        </section>

      <div
        className="text-center px-6"
        dangerouslySetInnerHTML={{ __html: data.bloque1 }}
      />
      <div className="pb-16 pt-4">
 
        <OfferLinea></OfferLinea>
        
      </div>
      <div>
        <DescuentosEnlinea></DescuentosEnlinea>
      </div>

      <div className="mt-10 bg-slate-50">
        <BlockRightImage
          src={data.imagen2}
          content={
            <>
              <div dangerouslySetInnerHTML={{ __html: data.bloque2 }} />
            </>
          }
        ></BlockRightImage>{" "}
      </div>
    </div>
   );
  };

  return (
    <>
      <DataFetcherTemplateHome url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplateHome>

      <div className="my-10 pt-4">
        <ConectUs
          lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes."
          instagram="https://www.instagram.com/utplenlinea/"
          facebook="https://www.facebook.com/utplenlinea/"
          tiktok="https://www.tiktok.com/@utplenlinea"
        ></ConectUs>
      </div>
    </>
  );
}

export default Enlinea;
